import { useLocalization } from '@fluent/react';
import { Box, Button, FormControlLabel, Switch, Typography } from '@material-ui/core';
import React, { useState } from 'react';

import ButtonGroup from '../../../../items/ButtonGroup';
import { DenmColors } from '../../../../routes/MapView/utils';

export enum TraceType {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}

interface MainTraceProps {
  selectedTraceIndex: number;
  highlightTrace: (index: number) => void;
  isDisabled: boolean;
  isActiveSelection: boolean;
  mainTraceLength: number;
  toggleSelectionMainTrace: (type: TraceType) => void;
  deleteMainTrace: () => void;
  /** When false, hides the delete button even if a main trace exists. Default true. */
  canDelete?: boolean;
}

export const MainTrace = ({
  selectedTraceIndex,
  highlightTrace,
  isDisabled,
  isActiveSelection,
  mainTraceLength,
  toggleSelectionMainTrace,
  deleteMainTrace,
  canDelete = true,
}: MainTraceProps) => {
  const { l10n } = useLocalization();
  const [automaticMainTrace, setAutomaticMainTrace] = useState<boolean>(true);

  // the mode switch only feeds the start-selection button, so both go away once a trace exists
  const showModeSelection = mainTraceLength <= 0;
  const showDelete = mainTraceLength > 0 && canDelete;

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        marginTop={'30px'}
        borderBottom={'1px dashed rgb(0, 90, 187)'}
        paddingBottom={'20px'}
        alignItems={'center'}
      >
        <Typography
          style={{
            alignSelf: 'center',
            cursor: 'pointer',
            borderLeft: selectedTraceIndex === -1 ? `4px solid ${DenmColors.TRACE_SELECTED}` : '',
            paddingLeft: selectedTraceIndex === -1 ? '10px' : '0px',
          }}
          variant="caption"
          onClick={() => (!isDisabled ? highlightTrace(-1) : null)}
        >
          {`${l10n.getString('forms-denm-single-trace-zone-main')}`}
          <span style={{ color: 'red', marginLeft: 5 }}>*</span>
        </Typography>
        <Box display={'flex'} alignItems={'center'} style={{ gap: 8 }}>
          {showModeSelection && (
            <FormControlLabel
              control={
                <Switch
                  checked={automaticMainTrace}
                  onChange={() => setAutomaticMainTrace(!automaticMainTrace)}
                  name="automaticMainTrace"
                  color="primary"
                  size="small"
                  disabled={isActiveSelection}
                />
              }
              label={
                automaticMainTrace
                  ? l10n.getString('forms-denm-set-automatic-main-trace')
                  : l10n.getString('forms-denm-set-manual-main-trace')
              }
              style={{ fontSize: 12 }}
            />
          )}
          {showDelete && (
            <Button
              variant="outlined"
              onClick={deleteMainTrace}
              color="primary"
              style={{ borderRadius: 20, textTransform: 'none', fontSize: '11px' }}
              size="small"
              disabled={isDisabled}
            >
              {l10n.getString('forms-denm-points-delete')}
            </Button>
          )}
        </Box>
      </Box>
      {showModeSelection && (
        <Box>
          <ButtonGroup
            text=""
            buttons={[
              {
                label: isActiveSelection
                  ? l10n.getString('forms-points-end-selection')
                  : l10n.getString('forms-points-start-selection'),
                disabled: isDisabled,
                color: 'primary',
              },
            ]}
            onClick={() => {
              toggleSelectionMainTrace(
                automaticMainTrace ? TraceType.AUTOMATIC : TraceType.MANUAL,
              );
            }}
          />
        </Box>
      )}
    </Box>
  );
};
